/** Opacité du triple flash rouge (sync avec @keyframes triFlash, 2.4s). */
const TRI_FLASH_KEYFRAMES = [
  [0, 0],
  [0.08, 1],
  [0.2, 0],
  [0.35, 1],
  [0.47, 0],
  [0.62, 1],
  [0.74, 0],
  [1, 0],
];

export const WAGER_FLASH_DURATION_MS = 2400;

export function getTriFlashOpacity(progress) {
  const t = Math.max(0, Math.min(1, progress));
  for (let i = 0; i < TRI_FLASH_KEYFRAMES.length - 1; i += 1) {
    const [t0, o0] = TRI_FLASH_KEYFRAMES[i];
    const [t1, o1] = TRI_FLASH_KEYFRAMES[i + 1];
    if (t >= t0 && t <= t1) {
      if (t1 === t0) return o1;
      const u = (t - t0) / (t1 - t0);
      return o0 + (o1 - o0) * u;
    }
  }
  return 0;
}

export function drawWagerStartFlash(ctx, width, height, flashRef) {
  const state = flashRef?.current;
  if (!state?.active || !state.startedAt) return;

  const elapsed = performance.now() - state.startedAt;
  if (elapsed < 0 || elapsed > WAGER_FLASH_DURATION_MS) return;

  const opacity = getTriFlashOpacity(elapsed / WAGER_FLASH_DURATION_MS);
  if (opacity <= 0.01) return;

  const cx = width / 2;
  const cy = height / 2;
  const radius = Math.max(width, height) * 0.7;
  const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius);
  grad.addColorStop(0, `rgba(239, 68, 68, ${0.7 * opacity})`);
  grad.addColorStop(0.7, "rgba(239, 68, 68, 0)");

  ctx.save();
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, width, height);
  ctx.restore();
}
